module.exports = __webpack_public_path__ + "static/media/logo-youtube-white.2989cd7d.svg";